import React from 'react';
import { useRouter } from 'next/router';
import { DestinationLinkBuilder, LinkItem } from '@model/iceberg';
import { HotelTile } from '@model/iceberg/hotel-content/hotel-content';
import { DealFinderTile } from '@components/common/deal-finder-tile/DealFinderTile';

export interface FromPriceByPathProductTileProps {
  testFlag?: boolean;
  testId?: string;
  className?: string;
  productPackage: HotelTile;
}

export const FromPriceByPathProductTile = ({ productPackage }: FromPriceByPathProductTileProps) => {
  if (!productPackage) return null;
  const router = useRouter();
  const { price, place, checkInDate, nights, boardBasis, hotelRating, tripAdvisorRating, gallery, featuredImage } =
    productPackage;
  const cheapestPrice: number = price.amount;
  const linkBuilder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const link: LinkItem = linkBuilder.getDestinationLink(place.hotel!.path);
  const handleOnClick = () => router.push(link.as);

  return (
    <DealFinderTile
      onClick={handleOnClick}
      result={{
        leadInPrice: {
          mealPlan: boardBasis,
          packageReferences: [],
          perPerson: {
            amount: cheapestPrice,
            currency: price.currency
          },
          total: {
            amount: cheapestPrice,
            currency: price.currency
          }
        },
        summary: {
          place,
          startDate: checkInDate,
          nights,
          hotelRating: Number(hotelRating),
          tripAdvisorRating,
          gallery,
          featuredImage,
          connectId: 0
        },
        otherPrices: []
      }}
    />
  );
};
